import Config from '../config/index.js';

class LocaleWrapper {
  static localeToIntl(locale) {
    return Object.keys(this.replacements).some(key => key === locale) ? this.replacements[locale] : locale;
  }
  static get locale() {
    var _a;
    return this.localeToIntl(((_a = globalThis.$locale) === null || _a === void 0 ? void 0 : _a.value) || Config.localeWrapper.fallbackLocale);
  }
}
LocaleWrapper.replacements = {
  kg: 'ky',
  ch: 'zh'
};

export { LocaleWrapper as default };
